import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { GzTextWebComponent } from '../../../../../ui/gzText';
import { GzButtonWebComponent } from '../../../../../ui/gzButton';
import { MspInProductTrialsOverlayWindowType } from '../../mspInProductTrialsOverlaysApp/types/MspInProductTrialsOverlayWindowType';
import { getContentConfigForMspInProductTrialsOverlayWindowType } from './configs/msp-in-product-trials-overlay-window-content-config';
import {
  MspInProductTrialsOverlayWindowButton,
  MspInProductTrialsOverlayWindowContentConfig,
} from '../types/MspInProductTrialsOverlayWindowContentConfig';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { translateFn } from '../../../../../utils/translator.helper';

export class MspInProductTrialsOverlayContentView extends BaseWebComponentView {
  public overlayWindowConfig: MspInProductTrialsOverlayWindowContentConfig;
  public overlayWindowType: MspInProductTrialsOverlayWindowType;

  public dom: {
    $wrapper: HTMLElement;

    $windowImage: HTMLImageElement;
    $windowTitle: GzTitleWebComponent;
    $windowText: GzTextWebComponent;

    $button1: GzButtonWebComponent;
    $button2: GzButtonWebComponent;
    $button3: GzButtonWebComponent;

    $dontShowThisAgainForm: GzFormFieldWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),

      $windowImage: this.shadow.querySelector('#msp-in-product-trials-overlay-window-image'),
      $windowTitle: this.shadow.querySelector('#msp-in-product-trials-overlay-window-title'),
      $windowText: this.shadow.querySelector('#msp-in-product-trials-overlay-window-text'),

      $button1: this.shadow.querySelector('#msp-in-product-trials-overlay-window-button1'),
      $button2: this.shadow.querySelector('#msp-in-product-trials-overlay-window-button2'),
      $button3: this.shadow.querySelector('#msp-in-product-trials-overlay-window-button3'),
      $dontShowThisAgainForm: this.shadow.querySelector('#msp-in-product-trials-overlay-window-checkbox'),
    };
  }

  buildSuccessView({
      inProductTrialsOverlayWindowType,
  }: {
      inProductTrialsOverlayWindowType: MspInProductTrialsOverlayWindowType;
  }) {
    this.overlayWindowType = inProductTrialsOverlayWindowType;
    this.overlayWindowConfig = getContentConfigForMspInProductTrialsOverlayWindowType(this.overlayWindowType);

    this.dom.$windowImage.src = this.overlayWindowConfig.imageSrc;
    this.dom.$windowTitle.innerText = this.overlayWindowConfig.title;
    this.dom.$windowText.innerHTML = this.overlayWindowConfig.text;

    // set buttons config
    this.setButtonElementConfig(this.dom.$button1, this.overlayWindowConfig.buttons.button1);
    this.setButtonElementConfig(this.dom.$button2, this.overlayWindowConfig.buttons.button2);
    this.setButtonElementConfig(this.dom.$button3, this.overlayWindowConfig.buttons.button3);

    this.dom.$dontShowThisAgainForm.Input.innerText = translateFn('Do not ask me again');
  }

  private setButtonElementConfig(button: GzButtonWebComponent, buttonConfig: MspInProductTrialsOverlayWindowButton) {
    button.innerText = buttonConfig.innerText;
    button.theme = buttonConfig.theme;
    button.color = buttonConfig.color;
    button.type = buttonConfig.type;
  }
}
